import { Fancybox } from "@fancyapps/ui/src/Fancybox/Fancybox.js";

const basketCounter = document.querySelector('.header-btn-cart b');
const basketMobileCounter= document.querySelector('.mobile-menu-btn-cart b');
const basketTotal = document.querySelector('.header-cart-price')
const basketPageCounter = document.querySelectorAll('.js-basketCount');
const basketPageTotal = document.querySelector('.js-basketTotal');
const addToBasketBtns = document.querySelectorAll('.js-addToBasket');
const basket = document.querySelector('#basket');
const mini_basket = document.querySelectorAll('.mini-basket');

function getCourseIdListener(e) {
  e.preventDefault();
  const btn = e.currentTarget;

  if ('disabled' === btn.getAttribute('disabled')) {
    return;
  }

  const {
    postId,
    prpi_isn,
  } = btn.dataset;
  sendProductInfo(postId, prpi_isn, 'add');
  btn.setAttribute("disabled", "disabled");
  btn.innerHTML = 'Added to basket';
}

function changeBasketCounter(count) {
  if (basketCounter instanceof HTMLElement && basketTotal instanceof HTMLElement) {
    basketCounter.innerHTML = count;
  }
  basketPageCounter.forEach( item => {
    if (item instanceof HTMLElement) {
      count > 0 ?
          item.classList.remove('hidden')
          : item.classList.add('hidden');
      item.innerHTML = count;
    }
  })
}

function sendProductInfo(postId, prpi_isn, action) {
  fetch(basket_data.endpoint, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({
      post_id: postId,
      prpi_isn,
      action,
    })
  })
    .then((response) => response.json())
    .then((data) => {
      changeBasketCounter(data.countItems);
      if ('add' === action) {
        Fancybox.show([
          {
            src: '<div class="basket-success"><p>This course has been added to your basket.</p><a href="' + basket_data.basketURL + '">Go to basket</a></div>',
            type: "html",
          },
        ]);
        //document.location.reload();
      }

      if ('getBasket' === action) {
        insertBasket(data);
      }

      if ('remove' === action) {
        if (basket instanceof HTMLElement) {
          document.location.reload();
        } else {
          reloadPage();
        }
      }

      insertMiniBasket(data);
    })
    .catch(error => console.log(error));
}

function removeMiniCartProduct(e) {
  const btn = e.target;
  if (!btn.classList.contains('js-removeFromBasket')) {
    return '';
  }
  e.preventDefault();
  const productRow = btn.closest('.popup-basket__item')
  const {
    postId,
    prpi_isn,
  } = productRow.dataset;
  sendProductInfo(postId, prpi_isn, 'remove');
  productRow.remove();
}

function removeProduct(e) {
  const btn = e.target;
  if (!btn.classList.contains('js-removeFromBasket')) {
    return '';
  }
  e.preventDefault();
  const productRow = btn.closest('.basket-card')
  const {
    postId,
    prpi_isn,
  } = productRow.dataset;
  sendProductInfo(postId, prpi_isn, 'remove');
  productRow.remove();
}

function reloadPage() {
  const productRows = document.querySelectorAll('.basket-card');
  if (0 === productRows.length) {
    document.location.reload();
  }
}

function getBasket() {
  sendProductInfo(0, 0, 'getBasket')
}

function insertBasket(data) {
  if (basket instanceof HTMLElement) {
    basket.innerHTML = data.basket.template;
  }
}

function insertMiniBasket(data) {
  mini_basket.forEach(item => {
    if (item instanceof HTMLElement) {
      item.innerHTML = data.mini_basket.template;
    }
  })

}

export default () => {
  addToBasketBtns.forEach(item => item.addEventListener('click', getCourseIdListener));
  getBasket();
  mini_basket.forEach(item => {
    if (item instanceof HTMLElement) {
      item.addEventListener('click', removeMiniCartProduct);
    }
  })

  if (basket instanceof HTMLElement) {
    basket.addEventListener('click', removeProduct);
  }
}
